<template>
  <a-card :bordered="false" :bodyStyle="{ padding: '16px 0', height: '100%' }" :style="{ height: '100%' }">
    <div class="account-settings-info-view">
      <a-row :gutter="16" type="flex" justify="center">
        <a-col :md="24" :lg="20">
          <a-form-model :model="addOrUpdateForm" ref="addOrUpdateForm" :rules="rules">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="片区选择" prop="zoneId">
              <a-tree-select
                :tree-data="zoneTreeData"
                v-model="addOrUpdateForm.zoneId"
                style="width: 100%"
                :replace-fields="{ title: 'zoneName', key: 'id', value: 'id', selectable: 'selectable' }"
                :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
                placeholder="请选择片区"
                allow-clear
                :treeDefaultExpandedKeys="treeDefaultExpandedKeys"
                show-search
              ></a-tree-select>
            </a-form-model-item>
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="日期">
              <div style="display: flex; flex-direction: column">
                <a-radio-group
                  :value="selectDay"
                  @change="changeRadio"
                  button-style="solid"
                  style="margin-bottom: 10px"
                >
                  <a-radio-button value="year">年份</a-radio-button>
                  <a-radio-button value="quarter">季度</a-radio-button>
                  <a-radio-button value="month">月份</a-radio-button>
                  <a-radio-button value="other">其他</a-radio-button>
                </a-radio-group>

                <div class="date-picker-wrapper" style="display: flex; align-items: center; flex-wrap: nowrap">
                  <a-date-picker
                    v-if="selectDay === 'year'"
                    mode="year"
                    format="YYYY"
                    v-model="addOrUpdateForm.daysTime"
                    placeholder="请选择年份"
                    :open="yearOpen"
                    @openChange="handleYearOpenChange"
                    @panelChange="handleYearPanelChange"
                    style="width: 150px"
                    :disabled-date="disabledDate"
                  />
                  <template v-else-if="selectDay === 'quarter'">
                    <a-date-picker
                      mode="year"
                      format="YYYY"
                      v-model="addOrUpdateForm.daysTime"
                      placeholder="请选择年份"
                      :open="yearOpen"
                      @openChange="handleYearOpenChange"
                      @panelChange="handleYearPanelChange"
                      style="width: 150px"
                      :disabled-date="disabledDate"
                    />
                    <a-select v-model="queryQuarter" placeholder="请选择季度" style="width: 120px; margin-left: 10px">
                      <a-select-option :value="1">第一季度</a-select-option>
                      <a-select-option :value="2">第二季度</a-select-option>
                      <a-select-option :value="3">第三季度</a-select-option>
                      <a-select-option :value="4">第四季度</a-select-option>
                    </a-select>
                  </template>
                  <a-month-picker
                    v-else-if="selectDay === 'month'"
                    v-model="addOrUpdateForm.daysTime"
                    placeholder="请选择月份"
                    style="width: 150px"
                    :disabled-date="disabledDate"
                  />
                  <a-range-picker
                    v-else-if="selectDay === 'other'"
                    v-model="rangeTime"
                    valueFormat="YYYY-MM-DD"
                    style="width: 240px"
                    :disabled-date="disabledDate"
                  />

                  <a-button type="primary" @click="handleGetData" :loading="loading" style="margin-left: 10px"
                    >获取数据</a-button
                  >
                </div>
              </div>
            </a-form-model-item>

            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="供水量(m³)" prop="waterSupply">
              <a-input placeholder="自产水量+外购水量" v-model="waterSupply" disabled />
            </a-form-model-item>
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="自产水量(m³)">
              <a-input placeholder="自产水量(m³)" v-model="addOrUpdateForm.selfProducedWater" />
            </a-form-model-item>
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="外购水量(m³)">
              <a-input placeholder="外购水量(m³)" v-model="addOrUpdateForm.purchasedWater" />
            </a-form-model-item>
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="售水量(m³)" prop="salesVolume">
              <a-input-number
                placeholder="售水量(m³)"
                v-model="addOrUpdateForm.salesVolume"
                :disabled="salesVolumedisabled"
                style="width: 100%"
                :min="salesVolumemin"
                :max="waterSupply"
              />
            </a-form-model-item>
            <a-form-model-item
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
              label="收费已计量用水量(m³)"
              prop="chargesMetered"
            >
              <a-input-number
                placeholder="请输入收费已计量用水量(m³)"
                v-model="addOrUpdateForm.chargesMetered"
                :max="waterSupply"
                style="width: 100%"
              />
            </a-form-model-item>

            <a-form-model-item
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
              label="收费未计量用水量(m³)"
              prop="chargesNotMetered"
            >
              <a-input-number
                v-model="addOrUpdateForm.chargesNotMetered"
                placeholder="请输入收费未计量用水量(m³)"
                :max="waterSupply"
                style="width: 100%"
              />
            </a-form-model-item>

            <a-form-model-item
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
              label="未收费已计量用水量(m³)"
              prop="notChargedMetered"
            >
              <a-input-number
                placeholder="请输入未收费已计量用水量(m³)"
                v-model="addOrUpdateForm.notChargedMetered"
                :max="waterSupply"
                style="width: 100%"
              />
            </a-form-model-item>

            <a-form-model-item
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
              label="未收费未计量用水量(m³)"
              prop="notChargedNotMetered"
            >
              <a-input-number
                placeholder="请输入未收费未计量用水量(m³)"
                v-model="addOrUpdateForm.notChargedNotMetered"
                :max="waterSupply"
                style="width: 100%"
              />
            </a-form-model-item>

            <a-form-model-item
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
              label="其他水量(m³)"
              prop="otherWaterVolumes"
            >
              <a-input-number
                placeholder="请输入其他水量(m³)"
                v-model="addOrUpdateForm.otherWaterVolumes"
                :max="waterSupply"
                style="width: 100%"
              />
            </a-form-model-item>
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="综合漏损率(%)">
              <a-input placeholder="综合漏损率" disabled v-model="comprehensiveLeakageRate" />
            </a-form-model-item>
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="漏损率(%)" prop="leakxzzbRate">
              <a-input placeholder="漏损率" disabled v-model="leakageRate" />
            </a-form-model-item>
            <a-form-model-item>
              <a-table size="middle" rowKey="id" :data-source="datasource" :columns="layerColumns" :pagination="false">
                <span slot="zbz" slot-scope="text, record, index">
                  <a-input-number v-model="zbz[index]" style="width: 150px"></a-input-number>
                </span>
                <span slot="xzz" slot-scope="text, record, index">
                  <span v-if="index == 0">{{ R1 }}</span>
                  <span v-else-if="index == 1"> {{ R2 }} </span>
                  <span v-else-if="index == 2"> {{ R3 }} </span>
                  <span v-else-if="index == 3"> {{ R4 }} </span>
                </span>
              </a-table>
            </a-form-model-item>
            <a-form-model-item>
              <a-button style="margin-left: 200px" type="primary" :loading="confirmLoading" @click="updateData"
                >录入</a-button
              >
            </a-form-model-item>
          </a-form-model>
        </a-col>
      </a-row>
    </div>
  </a-card>
</template>

<script>
import moment from 'moment'

export default {
  name: 'LeakageRate',
  components: {},
  data() {
    return {
      loading: false,
      yearOpen: false,
      layerColumns: [
        {
          title: '修正指标',
          dataIndex: 'xzzb',
          key: 'xzzb'
        },
        {
          title: '指标值',
          dataIndex: 'zbz',
          key: 'zbz',
          scopedSlots: { customRender: 'zbz' }
        },
        {
          title: '修正值（%）',
          key: 'xzz',
          dataIndex: 'xzz',
          scopedSlots: { customRender: 'xzz' }
        }
      ],
      zbz: [null, null, null, null],
      xzz: [],
      salesVolumemin: 0,
      salesVolumemax: 0,
      datasource: [
        {
          key: '1',
          xzzb: '居民抄表到户水量'
        },
        {
          key: '2',
          xzzb: '单位供水量管长（km/万m³）'
        },
        {
          key: '3',
          xzzb: '年平均供水压力（MPa）'
        },
        {
          key: '4',
          xzzb: '最大冻土深度（m）'
        }
      ],
      queryQuarter: 1,
      selectDay: 'year',
      rangeTime: null,
      requestType: 1,
      record: {},
      confirmLoading: false,
      salesVolumedisabled: false,
      labelCol: {
        xs: { span: 24 },
        sm: { span: 6 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 10 }
      },
      addOrUpdateForm: {
        daysTime: moment(),
        zoneId: undefined,
        waterSupply: '',
        measuredWaterVolume: '',
        freeWater: '',
        municipalWaterVolume: '',
        salesVolume: '',
        leakxzzbRate: '',
        degreeType: 2,
        selfProducedWater: '',
        purchasedWater: '',
        chargesMetered: '',
        chargesNotMetered: '',
        notChargedMetered: '',
        notChargedNotMetered: '',
        otherWaterVolumes: ''
      },
      flag: true,
      treeDefaultExpandedKeys: [], //默认展开的树节点
      rules: {
        daysTime: [{ required: true, message: '请选择时间' }],
        zoneId: [{ required: true, message: '请选择片区' }]
      },
      addUrl: '/pipe-network/zone_leakages',
      zoneTreeData: [], // 片区选项
      queryZoneDateUrl: 'zone-metering/zone-metering'
    }
  },
  computed: {
    //居民抄表到户水量 修正值
    // R1 = 0.08 × r × 100%，其中 r = 居民抄表到户水量的指标值 / 供水量
    R1() {
      if (this.zbz[0] && this.waterSupply && this.waterSupply > 0) {
        const r = this.zbz[0] / this.waterSupply
        return (0.08 * r * 100).toFixed(2)
      }
      return null
    },
    //单位供水量管长（km/万m³）修正值
    R2() {
      if (this.zbz[1]) {
        let data = (0.99 * (this.zbz[1] - 0.0693) * 100).toFixed(2)
        if (data > 3) {
          return 3
        } else if (data < -3) {
          return -3
        } else {
          return data
        }
      } else {
        return null
      }
    },
    //年平均供水压力 修正值
    R3() {
      if (0.35 < this.zbz[2] && this.zbz[2] <= 0.55) {
        return 0.5
      } else if (0.55 < this.zbz[2] && this.zbz[2] <= 0.75) {
        return 1
      } else if (0.75 < this.zbz[2]) {
        return 2
      } else {
        return null
      }
    },
    //最大冻土深度（m）修正值
    // 当深度 > 1.4m 时，修正值为 1%；否则为 0%
    R4() {
      if (this.zbz[3] !== null && this.zbz[3] !== undefined && this.zbz[3] !== '') {
        return this.zbz[3] > 1.4 ? 1 : 0
      }
      return null
    },
    //综合漏损率=（供水量-售水量）/供水量*100%；
    comprehensiveLeakageRate() {
      console.log('综合漏损率', this.addOrUpdateForm.salesVolume, this.salesVolumemax)
      //售水量=供水量
      if (this.salesVolumemax != 0 && this.addOrUpdateForm.salesVolume >= this.salesVolumemax) {
        return ((this.waterSupply - this.salesVolumemax) / this.waterSupply) * 100 || 0
      } else {
        return ((this.waterSupply - this.addOrUpdateForm.salesVolume) / this.waterSupply) * 100 || 0
      }
    },
    //漏损率=R1+R2+R3+R4（四个修正值相加）
    leakageRate() {
      const r1 = Number(this.R1) || 0
      const r2 = Number(this.R2) || 0
      const r3 = Number(this.R3) || 0
      const r4 = Number(this.R4) || 0
      return this.comprehensiveLeakageRate - Number((r1 + r2 + r3 + r4).toFixed(2))
    },
    //供水量：自动计算，不可手动填写，计算方式为“自产水量”+“外购水量”；
    //售水量：可自动计算，也可手动填写（不能大于供水量）， 计算方式为：“收费已计量”+“收费未计量”+“未收费已计量”+“未收费未计量”+“其他水量”；

    waterSupply() {
      let sum = Number(this.addOrUpdateForm.selfProducedWater) + Number(this.addOrUpdateForm.purchasedWater)
      this.addOrUpdateForm.salesVolume =
        Number(this.addOrUpdateForm.chargesMetered) +
        Number(this.addOrUpdateForm.chargesNotMetered) +
        Number(this.addOrUpdateForm.notChargedMetered) +
        Number(this.addOrUpdateForm.notChargedNotMetered) +
        Number(this.addOrUpdateForm.otherWaterVolumes)
      if (
        this.addOrUpdateForm.chargesMetered &&
        this.addOrUpdateForm.chargesNotMetered &&
        this.addOrUpdateForm.notChargedMetered &&
        this.addOrUpdateForm.notChargedNotMetered &&
        this.addOrUpdateForm.otherWaterVolumes
      ) {
        console.log(1)
        this.salesVolumedisabled = true
      } else if (
        !this.addOrUpdateForm.chargesMetered &&
        !this.addOrUpdateForm.chargesNotMetered &&
        !this.addOrUpdateForm.notChargedMetered &&
        !this.addOrUpdateForm.notChargedNotMetered &&
        !this.addOrUpdateForm.otherWaterVolumes
      ) {
        console.log(3)
        this.salesVolumedisabled = false
        // this.salesVolumemax = Number(sum)
      } else {
        console.log(2)
        this.salesVolumedisabled = false

        this.salesVolumemin = Number(this.addOrUpdateForm.salesVolume)
        this.salesVolumemax = Number(sum)
      }

      return sum
    }
  },
  methods: {
    getZoneData() {
      this.$http.get(this.queryZoneDateUrl).then(({ data }) => {
        this.zoneTreeData = data
        this.chuli(this.zoneTreeData)
      })
    },
    chuli(n) {
      if (n != null && n.length !== 0) {
        n.map((item) => {
          item.children = this.chuli(item.children)
          if (item.level == 1) {
            this.treeDefaultExpandedKeys.push(item.id)
          }
        })
        return n
      } else {
        return n
      }
    },
    handleYearOpenChange(open) {
      if (open) {
        this.yearOpen = true
      } else {
        this.yearOpen = false
      }
    },
    handleYearPanelChange(value) {
      this.addOrUpdateForm.daysTime = value
      this.yearOpen = false
    },
    // 限制日期不能选择今天之后
    disabledDate(current) {
      if (['year', 'month'].includes(this.selectDay)) {
        return current && current > moment().subtract(1, 'days').endOf('day')
      }
      return current && current > moment().endOf('day')
    },
    // 统一获取计算后的开始和结束日期
    getQueryDates() {
      let beginDate = ''
      let endDate = ''
      const today = moment().endOf('day')
      const yesterday = moment().subtract(1, 'days').endOf('day')

      if (this.selectDay === 'year' && this.addOrUpdateForm.daysTime) {
        beginDate = this.addOrUpdateForm.daysTime.clone().startOf('year').format('YYYY-MM-DD')
        endDate = this.addOrUpdateForm.daysTime.clone().endOf('year').format('YYYY-MM-DD')
      } else if (this.selectDay === 'quarter' && this.addOrUpdateForm.daysTime && this.queryQuarter) {
        const year = this.addOrUpdateForm.daysTime.year()
        const date = moment().year(year).quarter(this.queryQuarter)
        beginDate = date.clone().startOf('quarter').format('YYYY-MM-DD')
        endDate = date.clone().endOf('quarter').format('YYYY-MM-DD')
      } else if (this.selectDay === 'month' && this.addOrUpdateForm.daysTime) {
        beginDate = this.addOrUpdateForm.daysTime.clone().startOf('month').format('YYYY-MM-DD')
        endDate = this.addOrUpdateForm.daysTime.clone().endOf('month').format('YYYY-MM-DD')
      } else if (this.selectDay === 'other' && this.rangeTime && this.rangeTime.length === 2) {
        beginDate = this.rangeTime[0]
        endDate = this.rangeTime[1]
      }

      // 核心需求：年份和月份的 endDate 时间最多只能到昨天
      let limitDate = today
      if (['year', 'month'].includes(this.selectDay)) {
        limitDate = yesterday
      }

      if (endDate && moment(endDate).isAfter(limitDate)) {
        endDate = limitDate.format('YYYY-MM-DD')
      }

      return { beginDate, endDate }
    },
    changeRadio(e) {
      this.addOrUpdateForm.daysTime = moment()
      this.selectDay = e.target.value
      if (this.selectDay === 'year') {
        this.addOrUpdateForm.degreeType = 2
        this.requestType = 1
      } else if (this.selectDay === 'month') {
        this.addOrUpdateForm.degreeType = 0
        this.requestType = 3
      } else if (this.selectDay === 'quarter') {
        this.addOrUpdateForm.degreeType = 1
        this.requestType = 2
      } else {
        // 其他
        this.requestType = 4
        this.addOrUpdateForm.degreeType = 3
      }
    },
    handleGetData() {
      if (!this.addOrUpdateForm.zoneId) {
        this.$message.warning('请先选择片区')
        return
      }

      this.loading = true

      const { beginDate, endDate } = this.getQueryDates()

      const params = {
        zoneId: this.addOrUpdateForm.zoneId,
        beginDate,
        endDate
      }

      this.$http
        .get('/zone-metering/leakage/level/rule/water/balance', { params })
        .then(({ data }) => {
          if (data) {
            this.addOrUpdateForm.selfProducedWater = data.supplyWater
            this.$message.success('数据获取成功')
          }
        })
        .catch((err) => {
          console.error(err)
          this.addOrUpdateForm.selfProducedWater = ''
        })
        .finally(() => {
          this.loading = false
        })
    },

    //更新数据

    updateData() {
      this.$refs.addOrUpdateForm.validate((valid) => {
        if (valid) {
          this.confirmLoading = true
          const params = { ...this.addOrUpdateForm }

          params.waterSupply = this.waterSupply
          params.comprehensiveLeakageRate = this.comprehensiveLeakageRate
          params.leakageRate = this.leakageRate

          if (params.degreeType === 1) {
            // 季度
            params.daysTime = params.daysTime.format('YYYY') + '-' + this.queryQuarter
          } else if (params.degreeType === 2) {
            // 年份
            params.daysTime = params.daysTime.format('YYYY')
          } else if (params.degreeType === 0) {
            // 月份
            params.daysTime = params.daysTime.format('YYYY-MM')
          } else if (params.degreeType === 3) {
            // 其他
            params.daysTime = this.rangeTime[0] + ' 至 ' + this.rangeTime[1]
          }

          console.log(params)
          this.$http
            .post(this.addUrl, params)
            .then((res) => {
              if (res.code === 0) {
                this.$message.success(res.message)
                this.addOrUpdateForm = {
                  daysTime: moment(),
                  zoneId: undefined,
                  waterSupply: '',
                  measuredWaterVolume: '',
                  freeWater: '',
                  municipalWaterVolume: '',
                  salesVolume: '',
                  leakxzzbRate: '',
                  degreeType: 2,
                  selfProducedWater: '',
                  purchasedWater: '',
                  chargesMetered: '',
                  chargesNotMetered: '',
                  notChargedMetered: '',
                  notChargedNotMetered: '',
                  otherWaterVolumes: ''
                }
                this.zbz = [null, null, null, null]
                this.selectDay = 'year'
                this.rangeTime = null
              } else {
                this.$message.warning(res.message)
              }
            })
            .finally(() => {
              this.confirmLoading = false
            })
        }
      })
    }
  },
  created() {
    this.getZoneData()
  }
}
</script>

<style lang="less" scoped>
.avatar-upload-wrapper {
  height: 200px;
  width: 100%;
}

.ant-upload-preview {
  position: relative;
  margin: 0 auto;
  width: 100%;
  max-width: 180px;
  border-radius: 50%;
  box-shadow: 0 0 4px #ccc;

  .upload-icon {
    position: absolute;
    top: 0;
    right: 10px;
    font-size: 1.4rem;
    padding: 0.5rem;
    background: rgba(222, 221, 221, 0.7);
    border-radius: 50%;
    border: 1px solid rgba(0, 0, 0, 0.2);
  }

  .mask {
    opacity: 0;
    position: absolute;
    background: rgba(0, 0, 0, 0.4);
    cursor: pointer;
    transition: opacity 0.4s;

    &:hover {
      opacity: 1;
    }

    i {
      font-size: 2rem;
      position: absolute;
      top: 50%;
      left: 50%;
      margin-left: -1rem;
      margin-top: -1rem;
      color: #d6d6d6;
    }
  }

  img,
  .mask {
    width: 100%;
    max-width: 180px;
    height: 100%;
    border-radius: 50%;
    overflow: hidden;
  }
}
</style>
